import { createContext } from 'react';

const ExperimentContext = createContext({});

export default ExperimentContext;
